import React, { ReactElement } from 'react';
import {
  FlexContainer,
  Icon,
  IconName,
  IconWrapper,
  Label,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { StatusOperations } from '../../states';
import { LinkStyles } from '../results';
import { CardGridSmallProps } from './model';
import {
  CardGridInfoBar,
  CardGridSmallHeader,
  CardGridSmallStatus,
  CardGridStyles,
  CardResultsHeaderTitle,
} from './Styles';

export const CardGridSmall = ({
  title,
  className,
  icon,
  gridColumn,
  gridRow,
  alignSelf,
  order,
  message,
  iconStatus,
  loading,
  navigateTo,
  status,
  testId,
  infobarIcon,
  iconId,
  titleId,
  iconStatusId,
  infoBarId,
  infoBarTextId,
  infoBarIconId,
  messageId,
}: CardGridSmallProps) => {
  const { t } = useTranslation();
  const centerSpinner = loading && !icon;

  return (
    <CardGridStyles
      className={className}
      $gridColumn={gridColumn}
      $gridRow={gridRow}
      $alignSelf={alignSelf}
      order={order}
      title={title}
      testId={testId}
    >
      <>
        <CardGridSmallHeader justifyContent="space-between">
          {/* Message */}
          <FlexContainer flexDirection="column" rowGap="0.8">
            <CardResultsHeaderTitle id={titleId} testId={titleId}>
              {title}
            </CardResultsHeaderTitle>
            <Label
              fontSize="21"
              id={messageId}
              testId={messageId}
              semibold
              upperCase
            >
              {t(message)}
            </Label>
          </FlexContainer>
          {/* Status Icon */}
          <CardGridSmallStatus centerSpinner={centerSpinner}>
            {icon && (
              <IconWrapper
                iconName={icon}
                size="XL"
                shape="circle"
                color={'grey'}
                invertBackground={false}
                testId={iconId}
              />
            )}
            {iconStatus &&
              React.cloneElement(iconStatus as ReactElement, {
                className: 'status-icon',
                testId: iconStatusId,
              })}
          </CardGridSmallStatus>
        </CardGridSmallHeader>

        <CardGridInfoBar
          justifyContent={loading || !status ? 'flex-end' : 'space-between'}
          $type={loading ? 'loading' : status}
          testId={infoBarId}
        >
          {!loading && status && status !== StatusOperations.STARTED && (
            <Label
              fontSize="16"
              semibold
              upperCase
              testId={infoBarTextId}
              id={infoBarTextId}
            >
              {status === StatusOperations.CONNECTION_ERROR
                ? t('SERVICE NOT AVAILABLE')
                : t(`VALIDATION_${status}`)}
            </Label>
          )}
          {navigateTo &&
            status !== StatusOperations.CONNECTION_ERROR &&
            !loading && (
              <LinkStyles to={navigateTo}>{t('See more')}</LinkStyles>
            )}
          {infobarIcon?.length && !loading && (
            <FlexContainer id={infoBarIconId} testId={infoBarIconId}>
              {infobarIcon.map((icon: IconName, idx: number) => (
                <Icon iconName={icon} size="24" key={idx} />
              ))}
            </FlexContainer>
          )}
        </CardGridInfoBar>
      </>
    </CardGridStyles>
  );
};
